import React, { useState } from 'react';
import { ActionField, Field, useFormContext, withForm } from '@oscar/form';
import requestClient from '@oscar/request';
import { Button, Col, Layout, Row, Input, Alert } from '@oscar/theme';
import { useAuth } from 'features/auth';

const Login = () => {
  const [auth] = useAuth();
  const [formContext] = useFormContext();
  const [error, setError] = useState('');

  const onFinish = (value: any) => {
    if (value?.data) {
      if (value?.data?.message) {
        return setError(value?.data?.message);
      }
      requestClient
        .request({
          url: '/api/Account/Login',
          method: 'POST',
          data: {
            token: value?.data,
            userName: formContext.form?.getFieldValue('userName'),
          },
        })
        .then(res => {
          auth.authorizeData(res.toString());
          // window.location.href = '/';
        });
    }
  };

  return (
    <Layout>
      <Row>
        <Col span={12} offset={6}>
          <Field
            label="Username"
            name="userName"
            rules={[{ required: true, message: 'Please input user name!' }]}
          >
            <Input placeholder="Oscar_user_fe | Civil_Team_FE | Constractor_FE | Admin_FE" />
          </Field>

          {error && (
            <Alert
              style={{ marginBottom: '15px' }}
              message={error}
              type="error"
            />
          )}
          <ActionField
            name="submit"
            request={{
              name: 'submit',
              url: '/api/Account/LoginForTesting',
              method: 'POST',
              transformResponse: res => {
                try {
                  return { data: JSON.parse(res) };
                } catch (e) {
                  return { data: res };
                }
              },
            }}
            wrapperCol={{ offset: 8, span: 16 }}
            onResponseData={onFinish}
          >
            {(actionProps: any) => {
              return (
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => {
                    setError('');
                    actionProps.submitData();
                  }}
                >
                  Submit
                </Button>
              );
            }}
          </ActionField>
        </Col>
      </Row>
    </Layout>
  );
};

export default withForm({
  name: 'login',
})(Login);
